import React from "react";
import { Link } from "react-router-dom";
import "./HomeContent.css";
import healthcareRobot from "../../Components/Assets/productSubCategory/healthcareRobot.gif";
import massageSofa from "../../Components/Assets/productSubCategory/massageSofa.png";
import massageChair from "../../Components/Assets/productSubCategory/massageChair.png";

const ProductCategories = () => {
  return (
    <section className="product-categories-section">
      {/* Healthcare Robot */}
      <Link
        to="/bodyfriend-products?type=Healthcare%20Robot"
        className="product-category-item"
      >
        <div className="image-wrapper">
          <img src={healthcareRobot} alt="Healthcare Robot" />
        </div>
        <span className="product-name">Healthcare Robot</span>
        <p className="product-description">
          Powered by patented ROVO Technology for intelligent, personalised wellness 
        </p>
      </Link>

      {/* Massage Sofa */}
      <Link
        to="/bodyfriend-products?type=Massage%20sofa"
        className="product-category-item"
      >
        <div className="image-wrapper">
          <img src={massageSofa} alt="Massage Sofa" />
        </div>
        <span className="product-name">Massage Sofa</span>
        <p className="product-description">
          Stylish comfort with relaxing massage for modern everyday living
        </p>
      </Link>

      {/* Massage Chair */}
      <Link
        to="/bodyfriend-products?type=Massage%20Chair"
        className="product-category-item"
      >
        <div className="image-wrapper">
          <img src={massageChair} alt="Massage Chair" />
        </div>
        <span className="product-name">Massage Chair</span>
        <p className="product-description">
          Premium full-body massage for deeper relaxation and daily recovery
        </p>
      </Link>
    </section>
  );
};

export default ProductCategories;